import React from 'react';
import { getAccountInfo } from 'app/auth';
import { useAppSelector } from 'app/redux';
import ComputerPictogram from 'app/assets/Pictograms/Computer.svg';
import styles from './Presentation.module.scss';

export const Presentation: React.FC = () => {
  const userInfo = useAppSelector(getAccountInfo);
  const userName = userInfo?.name?.split(' ')[0];

  return (
    <div className={styles.presentation}>
      <span className={styles.wrapper}>
        <div className={styles.text}>
          {userName != null && (
            <p className={styles.salutation}>Hello {userName}...</p>
          )}
          <h3 className={styles.heading}>
            Let&apos;s turn your inputs to business outcomes
          </h3>
          <p>
            GenAI Business Services is a global platform for Zurich to support
            the scaling and reuse of AI. It&apos;s fast, it&apos;s flexible,
            it&apos;s secure and easy to integrate in your business and
            application landscape
          </p>
        </div>
        <img
          src={ComputerPictogram}
          alt="Computer processing data"
          aria-hidden
        />
      </span>
    </div>
  );
};
